import React, { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAlert } from "react-alert";
import Moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { deleteSavedExamSubjects, getAllSavedExamSubjects, saveExamSubjects } from "../../../actions/admin/examSubjectAction";
import { getCourseSubjects } from "../../../actions/subjectActions";
import Loader from "../../Loader";
import makeAnimated from "react-select/animated";
import Select from "react-select";

const ITEMS_PER_PAGE = 10;

const AdminRegisteredSubjects = ({ history }) => {
    const sloading = false;
    const dispatch = useDispatch()
    const { savedAllSubjects ,csloading} = useSelector((state) => state.examSubjects);
    const animatedComponents = makeAnimated();

    const { savedSubjects } = useSelector((state) => state.examSubjects);
    const { isSaved } = useSelector((state) => state.courseSubjects);
    const { courseSubjects } = useSelector((state) => state.courseSubjects);
    const [subjects, setSubjectsList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState("");

    // const userId = user._id;


    const [proceedSubjects, setProceedSubjects] = useState([]);

    useEffect(() => {
        dispatch(getAllSavedExamSubjects())
    }, [dispatch])

    // console.log("savedAll", savedAllSubjects);

    const handleCheck = () => {

    }

    const handleUpdate = (item) => {
        dispatch(getCourseSubjects(item?.course?._id, item?.exam?._id));
        localStorage.setItem("maxSubjects",item?.exam?.maximumSubjects);
        localStorage.setItem("exam", item?.exam?._id)
        localStorage.setItem("course", item?.course?._id)
        localStorage.setItem("subscriptionPlan", item?.subscriptionPlan?._id)
        localStorage.setItem("user", item?.user?._id)
        localStorage.setItem("category", item?.category?._id)
        history.push(`/admin/student-registered-subjects/update`)
    }

    const handleDelete = (item) => {

        dispatch(deleteSavedExamSubjects(item._id))
        dispatch(getAllSavedExamSubjects())


    }

    const subjectsList = ["Math", "Science", "English", "History"]; // Example list of subjects
    const [isModalOpen, setModalOpen] = useState(true);
    const [selectedSubject, setSelectedSubject] = useState('');

    const handleOpenModal = () => {
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
    };

    const handleUpdateSubject = () => {
        // Implement your update logic here
        handleCloseModal();
    };

    useEffect(() => {
        if (courseSubjects !== undefined && courseSubjects?.data?.length > 0) {
            const tmpArr = [];
            courseSubjects?.data?.map((course) => {
                tmpArr?.push({ label: course?.title, value: course?._id })
            })
            setSubjectsList(tmpArr)
        }
    }, [courseSubjects])

    // Filter data based on search term
    const filteredData = savedAllSubjects?.filter(item => {
        const searchLower = searchTerm.toLowerCase();
        const studentName = `${item?.user?.first_name || ''} ${item?.user?.last_name || ''}`.toLowerCase();
        const examType = (item?.exam?.title || '').toLowerCase();
        const planName = (item?.subscriptionPlan?.planName || '').toLowerCase();
        return studentName.includes(searchLower) || 
               examType.includes(searchLower) || 
               planName.includes(searchLower);
    }) || [];

    // Pagination calculations
    const totalItems = filteredData.length;
    const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE);
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;
    const paginatedData = filteredData.slice(startIndex, endIndex);

    // Reset to page 1 when search changes
    useEffect(() => {
        setCurrentPage(1);
    }, [searchTerm]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
        window.scrollTo(0, 0);
    };

    // Generate page numbers to display
    const getPageNumbers = () => {
        const pages = [];
        const maxVisiblePages = 5;
        
        if (totalPages <= maxVisiblePages) {
            for (let i = 1; i <= totalPages; i++) pages.push(i);
        } else {
            if (currentPage <= 3) {
                for (let i = 1; i <= 4; i++) pages.push(i);
                pages.push('...');
                pages.push(totalPages);
            } else if (currentPage >= totalPages - 2) {
                pages.push(1);
                pages.push('...');
                for (let i = totalPages - 3; i <= totalPages; i++) pages.push(i);
            } else {
                pages.push(1);
                pages.push('...');
                for (let i = currentPage - 1; i <= currentPage + 1; i++) pages.push(i);
                pages.push('...');
                pages.push(totalPages);
            }
        }
        return pages;
    };


    return (
        <Fragment>
            <div className="content-wrapper">
                <section className="content-header">
                    <h1>
                        Manage
                        <small>Student Registered Subjects</small>
                    </h1>
                    <ol className="breadcrumb">
                        <li>
                            <Link to="/admin">
                                <i className="fa fa-dashboard"></i> Dashboard
                            </Link>
                        </li>
                        <li className="active">Student Registered Subjects</li>
                    </ol>
                </section>

                <section className="content">
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="box">
                                <div className="box-header">
                                    <h3 className="box-title">Student Registered Subjects</h3>
                                    <div className="box-tools">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Search by name, exam, or plan..."
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                            style={{ width: '250px' }}
                                        />
                                    </div>
                                </div>
                                <div className="box-body table-responsive no-padding">
                                    <table className="table table-hover">
                                        <thead>
                                            <tr>
                                                <th>Student Name</th>
                                                <th>Exam Type</th>
                                                <th>Subscription Type</th>
                                                <th>Duration</th>
                                                <th>Price</th>
                                                <th>Subscribed At</th>
                                                <th>Expiration</th>
                                                <th>Status</th>
                                                <th>Registered Subjects</th>
                                                <th>Processed Subjects</th>
                                                <th>Update Request Subjects</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {csloading ? (
                                                <Loader
                                                   
                                                />
                                            ) : paginatedData !== undefined &&
                                                paginatedData?.length ? (
                                                paginatedData?.map((item) => (
                                                    <tr key={item._id}>
                                                        <td>
                                                            {item?.user?.first_name || item?.subscriptionPlan?.user?.first_name || ''} {item?.user?.last_name || item?.subscriptionPlan?.user?.last_name || ''}
                                                            {!item?.user?.first_name && !item?.subscriptionPlan?.user?.first_name && <span style={{color: '#999'}}>N/A</span>}
                                                        </td>
                                                        <td>{item?.exam?.title}</td>
                                                        <td>{item?.subscriptionPlan?.planName}{" "}{item?.subscriptionPlan?.subscriptionType}</td>
                                                        <td>{item?.subscriptionPlan?.duration}</td>
                                                        <td>₦{item?.subscriptionPlan?.price}</td>
                                                        <td>
                                                            {Moment(item?.subscriptionPlan?.subscribedAt).format("YYYY-MM-DD")}
                                                        </td>
                                                        <td>
                                                            {Moment(item?.subscriptionPlan?.expireAt).format("YYYY-MM-DD")}
                                                        </td>

                                                        <td>
                                                            {item?.status === true && (
                                                                <span className="badge bg-green">Active</span>
                                                            )}
                                                            {item?.subscriptionPlan?.status === false && (
                                                                <span className="badge bg-yellow">
                                                                    InActive
                                                                </span>
                                                            )}
                                                        </td>
                                                        <td>
                                                            <ul className="subject-list">
                                                                {item.subjects.length > 0 &&
                                                                    item.subjects.map((subject, iKey) => {
                                                                        return (
                                                                            <li id={iKey} key={iKey}>
                                                                                
                                                                                <label htmlFor={`subject-${subject?.subject?.id}`}>{iKey + 1}) {subject?.subject?.title} </label>
                                                                            </li>
                                                                        );
                                                                    })}
                                                            </ul>
                                                        </td>
                                                        <td>
                                                            <ul className="subject-list">
                                                                {item.subjectsProcessed.length > 0 &&
                                                                    item.subjectsProcessed.map((subject, iKey) => {
                                                                        return (
                                                                            <li id={iKey} key={iKey}>
                                                                               
                                                                                <label htmlFor={`subject-${subject.id}`}>{iKey + 1}) {subject.title} <i className="fa fa-check" style={{ color: "green" }} /> </label>
                                                                            </li>
                                                                        );
                                                                    })}
                                                            </ul>
                                                        </td>
                                                        <td>
                                                            <ul className="subject-list">
                                                                {item && item?.subjectsUpdate && item?.subjectsUpdate?.length > 0 ?
                                                                    item?.subjectsUpdate?.map((subject, iKey) => {
                                                                        return (
                                                                            <li id={iKey}>
                                                                               
                                                                                <label htmlFor={`subject-${subject.id}`}>{iKey + 1}) {subject.title}  </label>
                                                                            </li>
                                                                        );
                                                                    }) : "No Update Request"}
                                                            </ul>
                                                        </td>

                                                        <td>
                                                            <>

                                                                <button
                                                                    type="submit"
                                                                    className="btn btn-success btn-sm"
                                                                    onClick={() => handleUpdate(item)
                                                                    }

                                                                >Update

                                                                </button>

                                                                <>
                                                                    <button
                                                                        type="submit"
                                                                        className="btn btn-danger btn-sm"
                                                                        style={{ marginTop: "10px" }}
                                                                        onClick={() => handleDelete(item)
                                                                        }

                                                                    >Delete

                                                                    </button>
                                                                </>
                                                            </>

                                                        </td>

                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="12" style={{ textAlign: "center" }}>
                                                        No records found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                
                                {/* Pagination */}
                                {totalPages > 1 && (
                                    <div className="box-footer clearfix">
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <div>
                                                Showing {startIndex + 1} to {Math.min(endIndex, totalItems)} of {totalItems} entries
                                            </div>
                                            <ul className="pagination pagination-sm no-margin pull-right">
                                                <li className={currentPage === 1 ? 'disabled' : ''}>
                                                    <a 
                                                        href="#" 
                                                        onClick={(e) => { 
                                                            e.preventDefault(); 
                                                            if (currentPage > 1) handlePageChange(currentPage - 1); 
                                                        }}
                                                    >
                                                        «
                                                    </a>
                                                </li>
                                                {getPageNumbers().map((page, index) => (
                                                    <li 
                                                        key={index} 
                                                        className={page === currentPage ? 'active' : (page === '...' ? 'disabled' : '')}
                                                    >
                                                        <a 
                                                            href="#" 
                                                            onClick={(e) => { 
                                                                e.preventDefault(); 
                                                                if (page !== '...') handlePageChange(page); 
                                                            }}
                                                        >
                                                            {page}
                                                        </a>
                                                    </li>
                                                ))}
                                                <li className={currentPage === totalPages ? 'disabled' : ''}>
                                                    <a 
                                                        href="#" 
                                                        onClick={(e) => { 
                                                            e.preventDefault(); 
                                                            if (currentPage < totalPages) handlePageChange(currentPage + 1); 
                                                        }}
                                                    >
                                                        »
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                    </div>

                </section>
            </div>
        </Fragment>
    )
}

export default AdminRegisteredSubjects